import React, { useEffect, useState } from 'react';
import { Form, message, Select } from 'antd';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../../../../store/loading/actions';
import accountApis from '../../../../../services/accountApis';
import { CustomerType } from '../../../../../services/apisType';
import { useParams } from 'react-router-dom';


const SelectGroupCampaign = () => {
  const { id = '' } = useParams();
  const [lstGroup, setLstGroup] = useState<any>(null);

  const dispatch = useDispatch();
  const form = Form.useFormInstance();

  const handleOnchangeSelectGroupCampaign = async (value: string) => {
    if (value === '') {
      form.setFieldsValue({ customers: [] });
    } else {
      try {
        dispatch(setLoading(true));
        const response = await accountApis.getLstCustomerByGroup(value);
        if (response.status === 200) {
          const newListCustomer: CustomerType[] = response.data.data.map((item: any) => ({
            customerId: item.id,
            customerName: item.name,
            customerPhone: item.phone,
            email: item?.email || '',
            birthday: item?.birthday || '',
            point: item?.point || 0,
            lastVisitedDate: item?.lastVisitedDate || '',
            amountSpent: item?.amountSpent || 0,
          }));
          form.setFieldsValue({ customers: newListCustomer });
        } else {
          message.error({ content: response.data.message, duration: 2 });
        }
      } catch (error: any) {
        message.error({ content: error.message as string, duration: 2 });
      } finally {
        dispatch(setLoading(false));
      }
    }
  };

  const fetchData = async () => {
    try {
      const response = await accountApis.getLstGroupByShopId(id || '');
      if (response.status === 200) {
        setLstGroup(response.data.data);
      } else {
        message.error({ content: response.data.message, duration: 2 });
      }
    } catch (error: any) {
      message.error({ content: error.message as string, duration: 2 });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <Form.Item name='campaignCustomerSelectGroup'>
        <Select placeholder='Select' size='large' onChange={handleOnchangeSelectGroupCampaign}>
          <Select.Option key='' value=''>
            None
          </Select.Option>
          {lstGroup?.map((item: any) => (
            <Select.Option key={item.id} value={item.id}>
              {item.groupName}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
};

export default SelectGroupCampaign;
